<!--      Adress Information Section-->
<form class="address-form"
      *ngIf="addressForm"
      [formGroup]="addressForm"
      fxLayout="column">

    <!--        Country & City-->
    <div class="form-row-group"
         fxLayout="row"
         fxLayoutGap="10px"
         fxLayout.lt-sm="column">

        <!--          Country-->
        <div class="form-group control-country" fxFlex.lt-md="100%" fxFlex>
            <mat-form-field appearance="fill" fxFlex>
                <mat-label translate="shared.labels.country"></mat-label>
                <mat-select formControlName="countryCode"
                            (selectionChange)="onCountrySelect($event.value)">
                    <mat-option *ngFor="let country  of countryList"
                                [value]="country.code">{{country.name}}</mat-option>
                </mat-select>
                <mat-error translate="shared.validation.errors.countryRequired"></mat-error>
            </mat-form-field>
        </div>


        <!--          City / Province-->
        <div class="form-group control-city" fxFlex.lt-md="100%" fxFlex>

            <ng-container *ngIf="isDomesticAddress else internationalProvinceTemplate">
                <mat-form-field appearance="fill" fxFlex>
                    <mat-label translate="shared.labels.city"></mat-label>
                    <mat-select formControlName="cityName"
                                (selectionChange)="onCitySelect($event.value)">
                        <mat-option *ngFor="let city  of cityList"
                                    [value]="city.name">{{city.name}}</mat-option>
                    </mat-select>
                    <mat-error translate="shared.validation.errors.cityRequired"></mat-error>
                </mat-form-field>
            </ng-container>

            <ng-template #internationalProvinceTemplate>
                <mat-form-field appearance="fill" fxFlex>
                    <mat-label translate="shared.labels.province"></mat-label>
                    <input matInput
                           formControlName="province">
                </mat-form-field>
            </ng-template>


        </div>

    </div>

    <!--        Town-->
    <div class="form-group control-town" fxFlex.lt-md="100%" fxFlex>


        <ng-container *ngIf="isDomesticAddress else internationalCityTemplate">
            <mat-form-field appearance="fill" fxFlex>
                <mat-label translate="shared.labels.town"></mat-label>
                <mat-select formControlName="townName">
                    <mat-option *ngFor="let town  of townList"
                                [value]="town.name">{{town.name + ' ' }}</mat-option>
                </mat-select>
                <mat-error translate="shared.validation.errors.townRequired"></mat-error>
            </mat-form-field>
        </ng-container>

        <ng-template #internationalCityTemplate>
            <mat-form-field appearance="fill" fxFlex>
                <mat-label translate="shared.labels.city"></mat-label>
                <input matInput
                       formControlName="cityName">
                <mat-error translate="shared.validation.errors.cityRequired"></mat-error>
            </mat-form-field>
        </ng-template>
    </div>


    <!--        Address Line 1-->
    <div class="form-group control-line1" fxFlex.lt-md="100%" fxFlex>
        <mat-form-field appearance="fill" fxFlex>
            <mat-label translate="shared.labels.address"></mat-label>
            <input matInput formControlName="line1">
            <mat-error translate="shared.validation.errors.addressRequired"></mat-error>
        </mat-form-field>
    </div>


    <!--        Address Name-->
    <div *ngIf="isAddressNameVisible"
         class="form-group control-town" fxFlex.lt-md="100%" fxFlex>
        <mat-form-field appearance="fill"
                        charactersOnly
                        fxFlex>
            <mat-label translate="shared.labels.addressNamePlaceHolder"></mat-label>
            <input matInput formControlName="title">
            <mat-error translate="shared.validation.errors.addressNameRequired"></mat-error>
        </mat-form-field>
    </div>

</form>
